import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { Path, SVG } from '@wordpress/components';
/**
 * Internal dependencies
 */

var metadata = {
  name: "core/navigation-menu-item",
  category: "layout",
  attributes: {
    label: {
      type: "string"
    },
    nofollow: {
      type: "boolean",
      "default": false
    },
    title: {
      type: "string"
    },
    type: {
      type: "string"
    },
    description: {
      type: "string"
    },
    id: {
      type: "number"
    },
    opensInNewTab: {
      type: "boolean",
      "default": false
    },
    url: {
      type: "string"
    }
  }
};
import edit from './edit';
import save from './save';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Menu Item'),
  parent: ['core/navigation-menu'],
  icon: createElement(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24"
  }, createElement(Path, {
    d: "M12 7.27l4.28 10.43-3.47-1.53-.81-.36-.81.36-3.47 1.53L12 7.27M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2z"
  })),
  description: __('Add a page, link, or other item to your Navigation Menu.'),
  __experimentalDisplayName: 'label',
  edit: edit,
  save: save
};